export default __webpack_public_path__ + "static/media/DNo.24-3.bd38e9ec.jpg";